import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/core/services/api.service';
import { PaginationService } from 'src/app/core/services/pagination.service';

@Component({
  selector: 'app-inventory-transactions',
  templateUrl: './inventory-transactions.component.html',
  styleUrl: './inventory-transactions.component.scss',
  standalone: false
})
export class InventoryTransactionsComponent {
breadCrumbItems!: Array<{}>;
  
  // Data
  transactionList: any[] = [];
  allQualityCheckItems: any[] = [];
  materialAcceptances: any[] = [];
  items: any[] = [];
  
  // Filters
  materialAcceptanceId: string = '';
  itemId: string = '';
  transactionType: string = '';
  fromDate: string = '';
  toDate: string = '';
  
  // Loading
  isLoading = false;
  
  // Pagination
  page: number = 1;
  pageSize: number = 10;
  totalRecords: number = 0;

  constructor(
    private api: ApiService,
    public paginationService: PaginationService
  ) { }

  ngOnInit(): void {
    this.breadCrumbItems = [
      { label: 'Inventory Management' },
      { label: 'Transaction History', active: true }
    ];
    
    // Set default date range (last 15 days)
    const today = new Date();
    const fifteenDaysAgo = new Date();
    fifteenDaysAgo.setDate(today.getDate() - 15);
    
    this.toDate = this.formatDate(today);
    this.fromDate = this.formatDate(fifteenDaysAgo);
    
    this.loadMaterialAcceptances();
    this.loadItems();
    this.loadQualityCheckItems();
  }

  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  loadMaterialAcceptances(): void {
    this.api.get('/material_acceptances').subscribe({
      next: (res: any) => {
        if (res.success) {
          this.materialAcceptances = res.data || [];
        }
      },
      error: (err) => console.error('Error loading material acceptances:', err)
    });
  }

  loadItems(): void {
    this.api.get('/items').subscribe({
      next: (res: any) => {
        if (res.success) {
          this.items = res.data || [];
        }
      },
      error: (err) => console.error('Error loading items:', err)
    });
  }

  loadQualityCheckItems(): void {
    this.isLoading = true;
    
    let queryParams = `from_date=${this.fromDate}&to_date=${this.toDate}&page=${this.page}&limit=${this.pageSize}`;

    if (this.transactionType) {
      queryParams += `&movement_type=${this.transactionType}`;
    }
    
    if (this.itemId) {
      queryParams += `&item_id=${this.itemId}`;
    }
    
    this.api.get(`/inventory_transactions?${queryParams}`).subscribe({
      next: (res: any) => {
        this.isLoading = false;
        if (res.success) {
          this.transactionList = res.data || [];
          this.totalRecords = res.total || 0;
        }
      },
      error: (err) => {
        this.isLoading = false;
        console.error('Error loading transaction history:', err);
      }
    });
  }

  applyFilters(): void {
    this.page = 1;
    this.loadQualityCheckItems();
  }

  resetFilters(): void {
    this.materialAcceptanceId = '';
    this.itemId = '';
    this.page = 1;
    
    const today = new Date();
    const fifteenDaysAgo = new Date();
    fifteenDaysAgo.setDate(today.getDate() - 15);
    
    this.toDate = this.formatDate(today);
    this.fromDate = this.formatDate(fifteenDaysAgo);
    
    this.loadQualityCheckItems();
  }

  changePage(): void {
    this.loadQualityCheckItems();
  }

  
}

